(function($) {

	'use strict';

	var init = function() {
        scrollSection();

        scrollTop();

        $(window).scroll(scrollFixed).scroll();
	};

  var scrollFixed = function() {
    var delta = $(window).scrollTop() + $(window).innerHeight() - $('footer.mainFooter').offset().top;

    if(delta > 0) {
      $('.button-back').css('bottom', delta + 35 + 'px');
      $('.scroll_to_top').css('bottom', delta + 35 + 'px');
    } else {
      $('.button-back').css('bottom', '35px');
      $('.scroll_to_top').css('bottom', '35px');
    }
  }

	var scrollSection = function(){

        $('#scrollSection').click(function(){

            $('html, body').animate({
                scrollTop: $(window).outerHeight(),
              }, 600, 'swing', function() {
                // Animation complete.
              }
            );

        });

	};

  var scrollTop = function() {

    $('#scroll_to_top').click(function(){
      var href = $(this).attr('href');
      $('html, body').animate({
        scrollTop: $(href).offset().top
      }, 600, 'swing');

    });

    $(window).scroll(function() {
      if($(window).scrollTop() < 100) {
        $('.scroll_to_top').css('pointer-events', 'none')
        $('.scroll_to_top').css('opacity', '0')
      } else {
        $('.scroll_to_top').css('pointer-events', 'all')
        $('.scroll_to_top').css('opacity', '1')
      }
    }).scroll()
  }

	$(document).ready(function() {
		init();
	});

})(jQuery);
